<template>
  <div style="height: 500px;overflow: scroll;
  scrollbar-width: none;">
    <div class="school-info">
      <div class="school-info-icon"></div>
      <div class="school-info-title">下属学校基本情况</div>
    </div>
    <div>
      <div class="key-file-item">
        <div class="key-file-item-centen">
          <img src="@/assets/img/schoolBaseInfo/kindergarten-icon.png" alt="" />
          <div class="key-file-item-info">
            <div class="school-number">
              <span
                style="font-size:20px"
                v-if="eudInfo.sumOfSchoolTypesOfEducationBureau"
              >
                {{
                  eudInfo.sumOfSchoolTypesOfEducationBureau[0].count + "" || "0"
                }}
              </span>
              <span style="font-size:20px" v-else>0</span>
              所
            </div>
            <div class="school-type">幼儿园</div>
          </div>
        </div>
        <div class="key-file-item-centen">
          <img
            src="@/assets/img/schoolBaseInfo/primary-school-icon.png"
            alt=""
          />
          <div class="key-file-item-info">
            <div class="school-number">
              <span
                style="font-size:20px"
                v-if="eudInfo.sumOfSchoolTypesOfEducationBureau"
              >
                {{
                  eudInfo.sumOfSchoolTypesOfEducationBureau[1].count + "" || "0"
                }}</span
              >
              <span style="font-size:20px" v-else>0</span>
              所
            </div>
            <div class="school-type">小学</div>
          </div>
        </div>
      </div>
      <div class="key-file-item">
        <div class="key-file-item-centen">
          <img
            src="@/assets/img/schoolBaseInfo/middle-school-icon.png"
            alt=""
          />
          <div class="key-file-item-info">
            <div class="school-number">
              <span
                style="font-size:20px"
                v-if="eudInfo.sumOfSchoolTypesOfEducationBureau"
              >
                {{
                  eudInfo.sumOfSchoolTypesOfEducationBureau[2].count + "" || "0"
                }}</span
              >
              <span style="font-size:20px" v-else>0</span>
              所
            </div>
            <div class="school-type">初中</div>
          </div>
        </div>
        <div class="key-file-item-centen">
          <img src="@/assets/img/schoolBaseInfo/high-school-icon.png" alt="" />
          <div class="key-file-item-info">
            <div class="school-number">
              <span
                style="font-size:20px"
                v-if="eudInfo.sumOfSchoolTypesOfEducationBureau"
              >
                {{
                  eudInfo.sumOfSchoolTypesOfEducationBureau[3].count + "" || "0"
                }}</span
              >
              <span style="font-size:20px" v-else>0</span>
              所
            </div>
            <div class="school-type">高中</div>
          </div>
        </div>
      </div>
      <div class="key-file-item">
        <div class="key-file-item-centen">
          <img src="@/assets/img/schoolBaseInfo/rest-school-icon.png" alt="" />
          <div class="key-file-item-info">
            <div class="school-number">
              <span
                style="font-size:20px"
                v-if="eudInfo.sumOfSchoolTypesOfEducationBureau"
              >
                {{
                  eudInfo.sumOfSchoolTypesOfEducationBureau[4].count + "" || "0"
                }}</span
              >
              <span style="font-size:20px" v-else>0</span>
              所
            </div>
            <div class="school-type">其他</div>
          </div>
        </div>
      </div>
    </div>
    <div class="school-info"
              v-if="eudInfo.basicInformationOfEducationBureauQt">
      <div class="school-info-icon"></div>
      <div class="school-info-title">教育局基本信息</div>
    </div>
    <div class="school-info-detail"
              v-if="eudInfo.basicInformationOfEducationBureauQt">
      <div class="school-info-detail-box">
        <div style="width:50%">
          <div class="school-info-row-box">
            <div class="title">局长姓名:</div>
            <div class="conten">
              {{ eudInfo.basicInformationOfEducationBureauQt.director }}
            </div>
          </div>
          <div class="underline"></div>
        </div>
        <div style="width:50%">
          <div class="school-info-row-box">
            <div class="title">安全负责人:</div>
            <div class="conten">
              {{ eudInfo.basicInformationOfEducationBureauQt.safetyManager }}
            </div>
          </div>
          <div class="underline"></div>
        </div>
      </div>
      <div class="school-info-detail-box">
        <div style="width:50%">
          <div class="school-info-row-box">
            <div class="title">机构代码:</div>
            <div class="conten">
              {{
                eudInfo.basicInformationOfEducationBureauQt.organizationCode ||
                  "暂无数据"
              }}
            </div>
          </div>
          <div class="underline"></div>
        </div>
        <div style="width:50%">
          <div class="school-info-row-box">
            <div class="title">职工人数:</div>
            <div class="conten">
              {{ eudInfo.basicInformationOfEducationBureauQt.workersAmount }}
            </div>
          </div>
          <div class="underline"></div>
        </div>
      </div>
      <div class="school-info-detail-box">
        <div style="width:100%">
          <div class="school-info-row-box">
            <div class="title">地址:</div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                eudInfo.basicInformationOfEducationBureauQt.contactAddress
              "
              placement="top"
            >
              <div class="conten">
                {{ eudInfo.basicInformationOfEducationBureauQt.contactAddress }}
              </div>
            </el-tooltip>
          </div>
          <div class="underline"></div>
        </div>
      </div>
      <div class="school-info-detail-box">
        <div style="width:100%">
          <div class="school-info-row-box">
            <div class="title">联系方式:</div>
            <div class="conten">
              {{ eudInfo.basicInformationOfEducationBureauQt.phone }}
            </div>
          </div>
          <div class="underline"></div>
        </div>
      </div>
    </div>
    <div class="school-info">
      <div class="school-info-icon"></div>
      <div class="school-info-title">教育局管理架构</div>
    </div>
    <div class="manage-structure" v-if="
          eudInfo.basicInformationOfManagementStructure &&
            eudInfo.basicInformationOfManagementStructure.length > 0
        ">
      <div class="principal-list">
        <div
          class="principal-list-item"
          v-for="(item, index) in eudInfo.basicInformationOfManagementStructure"
          :key="index"
        >
          {{ item.position }}
        </div>
      </div>
      <img
        src="@/assets/img/schoolBaseInfo/principal-img.png"
        alt=""
        :height="eudInfo.basicInformationOfManagementStructure.length * 44"
      />
      
      <div class="principal-list">
        <div
          class="principal-list-item"
          v-for="(item, index) in eudInfo.basicInformationOfManagementStructure"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="principal-list">
        <div
          class="principal-list-item"
          v-for="(item, index) in eudInfo.basicInformationOfManagementStructure"
          :key="index"
        >
          {{ item.phone }}
        </div>
      </div>
    </div>
    <div v-else class="noData">
        暂无数据
      </div>
  </div>
</template>
<script>
export default {
  name: "eduBaseInfo",
  props: {
    eduDetail: {
      type: Object,
      default: {
        return: {}
      }
    },
    eduInfo: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    return {
      eudInfo: {},
      principalTitleList: ["第一负责人", "直接责任人", "安全管理人"], //教育局管理架构标题列表
      principalNameList: ["教育厅长", "安全主任", "分管副厅长"], //教育局管理架构标题列表
      principalTelList: ["13000212515", "13000212516", "13000212517"] //教育局管理架构标题列表
    };
  },
  mounted() {},
  methods: {
    async getInfo(val) {
      let req = {
        eduId: parseInt(val.eduId),
        regionCode: parseInt(val.regionCode),
        eduBureauType: parseInt(val.eduBuresuType)
      };
      let self = this;
      let res = await self.$Http.getEduDetailsCopy(req);
      if (res.code == 200) {
        if (res.data) {
          self.eudInfo = res.data[0] || {};
        }
      } else if (res.code == 101) {
      } else {
      }
    }
  },
  watch: {
    // eduDetail: function(val) {
    //   if (val) {
    //     this.getInfo(val);
    //   }
    // },
    eduInfo: {
      handler(val, oldVal) {
        this.getInfo(val);
      },
      deep: true
    }
  },
  computed: {
    // eduIdResize () {
    //     return this.$store.state.eduIdResize + ''
    // },
    // eduIdResizeInfo () {
    //     return this.$store.state.eduIdResizeInfo;
    // }
  }
};
</script>
<style scoped lang="scss">
.school-info {
  display: flex;
  flex-direction: row;
  height: 30px;
  margin-top: 5px;
  .school-info-icon {
    margin-left: 10px;
    width: 2px;
    height: 20px;
    margin-top: 5px;
    background-color: #3f8fbc;
  }
  .school-info-title {
    line-height: 30px;
    color: #ace1ff;
    font-size: 16px;
    margin-left: 10px;
  }
}
.school-info-detail {
  margin: 5px 4%;
  box-shadow: 1px 1px 10px 6px#3F78BC inset;
  //          来分别看一下以上六个值的含义：
  // 1px  从原点开始，沿x轴正方向的长度（倘若为负值，为沿x轴负方向的长度）；
  // 2px  从原点开始，沿y轴正方向的长度；（倘若为负值，为沿y轴负方向的长度）；
  // 3px  阴影的模糊度，只允许为正值；
  // 4px  阴影扩展半径；
  // #ccc  阴影颜色；
  // inset  设置为内阴影（如果不写这个值，默认为外阴影）；
  background-size: 100% 100%;
  .school-info-detail-box {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    .school-info-row-box {
      width: 100%;
      height: 42px;
      color: #ace1ff;
      display: flex;
      flex-direction: row;
      .title {
        margin-top: 20px;
        margin-left: 15px;
        font-size: 12px;
      }
      .conten {
        margin-top: 18px;
        margin-left: 15px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .underline {
      height: 2px;
      width: 80%;
      background-image: linear-gradient(
        to left,
        rgba(129, 134, 213, 0),
        rgba(63, 120, 188, 0.8),
        rgba(#4a4eab, 0)
      );
    }
  }
}
.manage-structure {
  display: flex;
  flex-direction: row;
  margin-left: 4%;
  .principal-list {
    width: 30%;
    display: flex;
    flex-direction: column;
    .principal-list-item {
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      color: #ace1ff;
    }
  }
  img {
    width: 13px;
  }
}
.key-file-item {
  width: 100%;
  height: 66px;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  .key-file-item-centen {
    margin-left: 4%;
    width: 44%;
    height: 70px;
    color: #b2e3ff;
    background: url("~@/assets/img/schoolBaseInfo/school-info-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    img {
      margin-left: 5px;
      margin-top: 10px;
      height: 50px;
      width: 50px;
    }
    .key-file-item-info {
      display: flex;
      flex-direction: column;
      text-align: center;
      .school-number {
        font-size: 14px;
        height: 28px;
        margin-top: 10px;
        margin-left: 10px;
      }
      .school-type {
        height: 20px;
        font-size: 14px;
        margin-left: 10px;
        margin-top: 5px;
      }
    }
  }
}
.noData {
  height: 60px;
  width: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
